import { BaseDialogConfigs } from '../../core/base-configs/base-modals.config';
import { CustomDialogSettings } from '../../core/services/custom-dialog.service';
import { AccountFormComponent } from '../components/account-form/account-form.component';

export class AccountDialogConfigs extends BaseDialogConfigs {
  private static readonly ENTITY_NAME = 'Account';

  static readonly EDIT_ACCOUNT: CustomDialogSettings = {
    title: 'Account',
    component: AccountFormComponent,
    ...this.SIZES.MEDIUM,
    minWidth: 500,
    minHeight: 400,
    actions: [this.ACTIONS.CANCEL, this.ACTIONS.SAVE],
    actionsLayout: 'end',
    cssClass: 'account-edit-dialog',
    autoFocus: true,
    closeButton: true,
  };
}
